var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"ourContainer"},[_c('Disciplines')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }